import './listing-details-container.css';

import { Helmet } from 'react-helmet-async';
import { IListing } from '../models/listing.model';
import { MutableRefObject, useEffect, useRef } from 'react';
import { IBranding } from '../models/branding.model';
import { Header } from './components/header';
import ListingDetails from './components/listing-details';

export interface ListingDetailsContainerProps {
  listing: IListing | null;
  closeUrl: MutableRefObject<string>;
  isSavedListing: boolean;
  branding: IBranding;
  addSavedListing(value: IListing | null): void;
  removeSavedListing(value: IListing | null): void;
  close?(): void;
}

export const ListingDetailsContainer = (props: ListingDetailsContainerProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const currentDomain = window.location.hostname;

  const handleClickOutside = (event: any) => {
    if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
      props.close !== undefined && props.close();
    }
  };

  useEffect(() => {
    // Mount the element
    document.body.classList.add('disable-body-scroll');
    // Unmount the element and enable body scroll when the component is unmounted
    return () => {
      document.body.classList.remove('disable-body-scroll');
    };
  }, []);

  useEffect(() => {
    props.close !== undefined &&
      document.addEventListener("click", handleClickOutside)
    return () => {
      props.close !== undefined &&
        document.removeEventListener("click", handleClickOutside);
    };
  });

  if (props.listing === null) {
    return (
      <>
        <Helmet>
          <title>Listing Not Available</title>
        </Helmet>
        <div className="listing-details-container-wrapper">
          <div id="listing-details-container" className="listing-details-container">
            <Header branding={props.branding} listing={props.listing} isSaved={props.isSavedListing} closeUrl={props.closeUrl} addSavedListing={props.addSavedListing} removeSavedListing={props.removeSavedListing} />
            <div ref={ref => (containerRef.current = ref)} className="listing-details-container-inside">
              <div className="listing-not-available">
                <h1>Listing not available.</h1>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{props.listing.title}</title>
        <meta name="description" content={props.listing.metaDescription} />
        <link rel="canonical" href={props.listing.uri} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <meta name="dc.source" content={currentDomain} />
        <meta name="dc.relation" content={props.listing.uri} />
        <meta property="og:url" content={props.listing.uri} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={props.listing.title} />
        <meta name="twitter:card" content={props.listing.metaDescription} />
        <meta name="twitter:title" content={props.listing.title} />
      </Helmet>
      <div className="listing-details-container-wrapper">
        <div id="listing-details-container" className="listing-details-container">
          <Header branding={props.branding} listing={props.listing} isSaved={props.isSavedListing} closeUrl={props.closeUrl} addSavedListing={props.addSavedListing} removeSavedListing={props.removeSavedListing} />
          <div ref={ref => (containerRef.current = ref)} className="listing-details-container-inside">
            <ListingDetails
              branding={props.branding}
              listing={props.listing}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ListingDetailsContainer;